import type { ComponentProps } from 'react'
import { useRef } from 'react'
import CalendarDatePickerSelectBox from './CalendarDatePickerSelectBox'
import CalendarDatePicker from './CalendarDatePicker'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import type DropdownSheet from 'LuxKit/Dropdown/Sheet/DropdownSheet'
import DropdownSheetBase from 'LuxKit/Dropdown/Sheet/DropdownSheetBase'
import { useAssistantSurfaceDropdownBoundary } from 'tripPlanner/assistant/layout/AssistantSurfaceLayoutContext'

interface Props extends Pick<ComponentProps<typeof DropdownSheet>, 'boundaryRef' | 'open'> {
  open: boolean
  className?: string
}

function CalendarDatePickerSelect(props: Props) {
  const {
    open,
    className,
    boundaryRef,
  } = props

  const dropdownRef = useRef<HTMLDivElement>(null)
  const container = useRef<HTMLDivElement>(null)
  const trigger = useRef(null)
  const dropdownBoundary = useAssistantSurfaceDropdownBoundary(boundaryRef)

  return (<div ref={container} className={className}>
    <CalendarDatePickerSelectBox ref={trigger} />
    <DropdownSheetBase
      ref={dropdownRef}
      anchorRef={trigger}
      triggerRef={trigger}
      autoHeight={dropdownBoundary.autoHeight}
      boundaryRef={dropdownBoundary.boundaryRef}
      size="L"
      open={open}
      portaled={dropdownBoundary.portaled}
    >
      <CalendarDatePicker />
    </DropdownSheetBase>
  </div>
  )
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'checkin',
}), CalendarDatePickerSelect)
